import { IntegrationProviderSchema } from '@rhythmic/types'
import type { CollectionBuildRequestConfig } from '../CollectionRegistry/CollectionBuilder.types'

export const INTEGRATION_PROVIDER_TABLE = '"public"."integrationProviders"'

export const IntegrationProviderConfig: CollectionBuildRequestConfig = {
  collectionType: 'query',
  table: INTEGRATION_PROVIDER_TABLE,
  key: 'id',
  apiEndpoint: '/api/integration-providers',
  where: {
    scope: 'global',
  },
  schema: IntegrationProviderSchema,
}
